import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StyleClassModule } from 'primeng/styleclass';
import { AppFooter } from './app.footer';
import { AppHeader } from './app.header';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, AppHeader, AppFooter, RouterModule, StyleClassModule],
  styles: ['section {scroll-margin-top: 60px;}'],
  template: `<div
    class="resize-container-6 min-h-screen h-full w-full bg-surface-0 dark:bg-surface-950"
  >
    <div class="flex flex-col flex-auto w-full">
      <!-- UNICO SCROLL -->
      <div class="px-0 flex flex-col flex-auto">
        <app-header></app-header>
        <div class="bg-surface-0">
          <main>
            <router-outlet></router-outlet>
          </main>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div> `,
})
export class AppLayout {
  constructor() {}
}
